<template>
  <body class="body">
    <EuSustainability />
    <About />
    <Benefits />
    <BannerIncrease />
    <MarketingSection />
    <BannerEffective />
  </body>
</template>

<script>
import EuSustainability from "./AboutSection/EuSustainability.vue";
import About from "./AboutSection/About.vue";
import Benefits from "./AboutSection/Benefits.vue";
import BannerIncrease from "./ReusableComponents/Banners/BannerIncrease.vue";
import MarketingSection from "./AboutSection/MarketingSection.vue";
import BannerEffective from "./ReusableComponents/Banners/BannerEffective.vue";

export default {
  name: "AboutSection",
  components: {
    EuSustainability,
    About,
    Benefits,
    BannerIncrease,
    MarketingSection,
    BannerEffective,
  },
};
</script>

<style scoped>
.body {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0px 34px;
}
@media (max-width: 744px) {
  .body {
    margin: 0px 16px;
    gap: 16px;
  }
}
</style>
